export const API_ENDPOINTS = {
  AGENT_LOGIN: "/agent-login",
  GET_AGENT_INFO: "/agent",
  LOGOUT: "/agent/logout",
  CUSTOMER_SEARCH: "/agent/customer_search",
  PAST_ORDERS: "/agent/past_orders",
  CREATE_CUSTOMER: "/customer/registration",
  CREATE_NEW_ADDRESS: "/agent/customer_address/create",
  UPDATE_ADDRESS: "/agent/address/:addressId",
  ALL_AREAS: "/agent/list-all-areas",
  SUPPORT_DELIVERY_BY_AREA: "/restaurant/support-delivery-by-area",
  BRANCH_ID_FROM_DELIVERY_AREAS: "/branch-id-from-delivery-areas",
  RESTAURANT: "/restaurant",
  ADD_TO_CART: "/add-to-cart",
  ADD_TO_CATERING_CART: "/agent/catering/add-to-cart",
  CHECK_ITEM_AVAILABILITY: '/menu-items/check-availability',
  PROCESS_ORDER: '/agent/process-manual-order',
  ORDER_STATUS: '/agent/order/status',
  EMPTY_CART: '/empty-cart',
  ALL_RESTAURANTS: '/homepage/restaurants',
  RESTAURANT_BRANCHES: "/restaurant/:restaurantId/branches", 
  ORDER: "/agent/order/:orderId",
  UPDATE_CUSTOMER: "/agent/customer_edit/:customerId",
  
  // Company endpoints
  COMPANY_SEARCH: "/agent/company_search",
  COMPANY_CREATE: "/agent/company_create",
  COMPANY_EDIT: "/agent/company_edit/:companyId",
  COMPANY_ADDRESS_CREATE: "/agent/company_address/create",
  COMPANY_ADDRESS_UPDATE: "/agent/company_address_update/:addressId",
  
  // Account managers and bank names endpoints
  ACCOUNT_MANAGERS_LIST: "/agent/account_managers/list",
  BANK_NAMES_LIST: "/agent/bank_names/list",
  
  // Catering endpoints
  ADD_TO_CATERING_CART: "/agent/catering-service-items/add-to-cart",
  CATERING_CART_LIST: "/agent/catering-service-items/cart-list",
  UPDATE_CATERING_CART: "/agent/catering-service-items/update-cart",
  DELETE_CATERING_CART: "/agent/catering-service-items/delete-cart",
  PROCESS_CATERING_MANUAL_ORDER: "/agent/catering-service-items/process-manual-order",
  CATERING_ORDER_STATUS: "/agent/catering-order/status",
  CATERING_PAST_ORDERS: "/agent/catering-service-order/past_orders",
  CATERING_ORDER_DETAILS: "/agent/catering-service-order/:orderId",
  UPDATE_CATERING_PAID_ORDER: "/agent/catering-service-order/update-paid-order-items",
  RESEND_CATERING_PAYMENT_LINK: "/agent/catering-service-items/resend-url-same-order",
};
